/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateKeyTestDto
 */
export interface CreateUpdateKeyTestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyTestDto
     */
    testId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateKeyTestDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateKeyTestDto interface.
 */
export function instanceOfCreateUpdateKeyTestDto(value: object): value is CreateUpdateKeyTestDto {
    return true;
}

export function CreateUpdateKeyTestDtoFromJSON(json: any): CreateUpdateKeyTestDto {
    return CreateUpdateKeyTestDtoFromJSONTyped(json, false);
}

export function CreateUpdateKeyTestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateKeyTestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'testId': json['testId'] == null ? undefined : json['testId'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreateUpdateKeyTestDtoToJSON(value?: CreateUpdateKeyTestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'testId': value['testId'],
        'name': value['name'],
    };
}

